import { render, staticRenderFns } from "./EditRolesModal.vue?vue&type=template&id=5d88de6f&scoped=true&"
import script from "./EditRolesModal.vue?vue&type=script&lang=js&"
export * from "./EditRolesModal.vue?vue&type=script&lang=js&"
import style0 from "./EditRolesModal.vue?vue&type=style&index=0&id=5d88de6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d88de6f",
  null
  
)

export default component.exports